import React from 'react'
import parser from 'html-react-parser'

export default function ContentBlocks9({data}) {
    const {contentBlocks9Subtitle, contentBlocks9Title, contentBlocks9Blocks} = data
    return (
        <div className='home-sec-1'>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-12 text-center'>
                        <h2 className='heading-level-1-i span-green'>
                            {contentBlocks9Title && parser(contentBlocks9Title)}
                        </h2>
                        <h3 className='heading-level-3'>{contentBlocks9Subtitle && parser(contentBlocks9Subtitle)}</h3>
                    </div>
                </div>
                <div className='row'>
                    {contentBlocks9Blocks?.map((item, index) => (
                        <div className='col-md-6 h-sec-1-col' key={index}>
                            <div className='h-white-box-1'>
                                <h4 className='heading-level-4 blue-color text-center'>
                                    {item.contentBlocks9BlockTitle}
                                </h4>
                                <p>{item.contentBlocks9BlockText && parser(item.contentBlocks9BlockText)}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}
